import { useState } from "react";

import { Client } from "@/Common/Api/Client";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import * as ServerOperations from "@/Common/Operations/operations.server";

interface IResendFaxButtonProps {
    sentFaxItemId: string;
    sentFaxIds: number[];
}

function ResendFaxButton(props: IResendFaxButtonProps): JSX.Element {
    const { getText } = useTranslation();
    const [loading, setLoading] = useState(false);

    async function resendFaxes(): Promise<void> {
        if (!loading) {
            setLoading(true);

            const response = await Client.postAsync(ServerOperations.Server.Myle_Faxing_ResendFax, { SentFaxIds: props.sentFaxIds, WithSignature: true });

            if (response.errors.any())
                sessionStore.showPopup(getText("OneOrMoreFaxesCouldNotBeResentLabel"));
            else if (props.sentFaxItemId)
                await patientStore.ActionsMedicalNote.loadSentFaxes([props.sentFaxItemId]);

            setLoading(false);
        }
    }

    return (
        <a
            onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                resendFaxes();
            }}
        >
            {getText("ResendLabel")}
        </a>
    );
}

export { ResendFaxButton };
